import "./AddCategory.scss";
import { useState } from "react";

function AddCategory() {
  const [categoryName, setCategoryName] = useState("");

  const handleSave = () => {
    if (!categoryName.trim()) {
      alert("Category name cannot be empty");
      return;
    }

    fetch(`${process.env.REACT_APP_BASE_URL}api/product/add-category`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ categoryName }),
    })
      .then((res) => res.json())
      .then((data) => {
        alert("Category saved successfully!");
        //console.log("Manufacturer saved successfully:", data);
        setCategoryName(""); // reset input after saving
      })
      .catch((err) => console.error("Error saving manufacturer:", err));
  };

  return (
    <div className="ac-container">
      <div className="ac-input-wrapper">
        <label>Category Name:</label>
        <input
          type="text"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
        />
      </div>
      <div className="ac-btn-action-wrapper">
        <button className="cancel-btn">Cancel</button>
        <button className="save-btn" onClick={handleSave}>
          Save
        </button>
      </div>
    </div>
  );
}

export default AddCategory;
